import React from 'react';
import { Icon } from 'antd';
import DWA from 'actions/dod/dodWelcomeActions';

const init = {
    stepStatus: 'invalid',
    description: 'Welcome',
    title: (
        <div id ='Welcome'>
            <Icon type='home'/>
            {' Step 1'}
        </div>
    )
};

export default (state=init, action) => {
    switch(action.type) {
        case DWA.UPDATE_DOD_WELCOME_STATUS:
            return {...state, stepStatus: action.payload };

        case DWA.UPDATE_DOD_WELCOME_TITLE:
            return {...state, title: action.payload };

        default: return {...state}
    }
}
